const ONBOARDING_ACCESS_AUTHORIZATION_ENDPOINT = {
  absoluteUrl: `https://api.${window.ENVIRONMENT}.wp.openbankpay.com/cf-api-login/v1/token/tokens-by-claims`,
};

export { ONBOARDING_ACCESS_AUTHORIZATION_ENDPOINT };
